// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12WgW","largestCol":"styles_largestCol__1SaEU","smallestCol":"styles_smallestCol__3W63k"};